
import styled from 'styled-components'

export const AstroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 607px;
 `
